import { useCallback } from 'react'

import { PostHogService, TrackingService } from '@/services/tracking'

export const useTracking = () => {
  const captureEvent = useCallback(
    (event: string, properties?: Record<string, any>) => {
      TrackingService.captureEvent(event, properties)
    },
    []
  )

  const captureException = useCallback((error: Error) => {
    TrackingService.captureException(error)
  }, [])

  const setPersonProperties = useCallback((properties: Record<string, any>) => {
    PostHogService.setPersonProperties(properties)
  }, [])

  const joinGroup = useCallback(
    (
      groupType: string,
      groupKey: string,

      properties?: Record<string, any>
    ) => {
      PostHogService.group(groupType, groupKey, properties)
    },
    []
  )

  return {
    captureEvent,
    captureException,
    setPersonProperties,
    joinGroup,
  }
}
